module.exports = __webpack_public_path__ + "images/category_lp/common/frame-advantage_ef542655e4fd867bd2c5254ddec6943d.png";